// Styles
import './newsletter-banner.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initNewsletterBanner = (context) => {
  const newsletterBannerSection = context.closest('.shopify-section');
}

if(document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.newsletter-banner__container'), (el) => {
    window.dAgency.initNewsletterBanner(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.newsletter-banner__container'), (el) => {
      window.dAgency.initNewsletterBanner(el);
    });
  });
}
